"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1207],{

/***/ 13897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_G": function() { return /* binding */ getRealestate; },
  "mW": function() { return /* binding */ getRealestateDetails; },
  "t5": function() { return /* binding */ getRealestateLog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/realestate.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var RealestateStatic;

(function (RealestateStatic) {
  RealestateStatic["RealestateList"] = "/v2/realestates";
  RealestateStatic["realestatesForSelect"] = "/v2/realestates/for-select";
})(RealestateStatic || (RealestateStatic = {}));

var RealestateDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description Get realestate details
   */
  RealestateDetail: function RealestateDetail(RealestateId) {
    return "v2/realestates/".concat(RealestateId);
  },

  /**
  * @member {string}
  * @method GET
  * @version 2.0
  * @description Send realestate log
  */
  RealEstateLog: function RealEstateLog(RealestateId) {
    return "v2/realestates/".concat(RealestateId, "/log-activity");
  }
};
var RealestateEndpoints = _objectSpread(_objectSpread({}, RealestateStatic), RealestateDynamic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/realestate.request.ts




var getRealestate = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(filters) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0,base_services_request/* getRequest */.A_)(RealestateEndpoints.RealestateList, filters).then(function (response) {
              return response === null || response === void 0 ? void 0 : response.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getRealestate(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getRealestateLog = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(id) {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", (0,base_services_request/* getRequest */.A_)(RealestateEndpoints.RealEstateLog(id)).then(function (res) {
              return res.data;
            })["catch"](function (err) {
              return err.response;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getRealestateLog(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getRealestateDetails = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(id, filters) {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", (0,base_services_request/* getRequest */.A_)(RealestateEndpoints.RealestateDetail(id), filters).then(function (response) {
              return response === null || response === void 0 ? void 0 : response.data;
            })["catch"](function (error) {
              return error.response;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getRealestateDetails(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 14788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ getSector; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/sectors.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SectorsStatic;

(function (SectorsStatic) {
  SectorsStatic["SectorsList"] = "/v2/sectors";
})(SectorsStatic || (SectorsStatic = {}));

var SectorsDynamic = {// /**
  //  * @member {string}
  //  * @method GET
  //  * @version 2.0
  //  * @description get Sectors details
  //  */
  // SectorsDetail: (SectorsID?: number) =>
  //   `/v1/Sectors/${SectorsID}`,
};
var SectorsEndpoints = _objectSpread(_objectSpread({}, SectorsDynamic), SectorsStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/sector.request.ts


var getSector = function getSector(filters) {
  return (0,base_services_request/* getRequest */.A_)(SectorsEndpoints.SectorsList, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};

/***/ }),

/***/ 78647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCities; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/cities.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var citiesStatic;

(function (citiesStatic) {
  citiesStatic["citiesList"] = "/v2/cities";
})(citiesStatic || (citiesStatic = {}));

var citiesDynamic = {// /**
  //  * @member {string}
  //  * @method GET
  //  * @version 2.0
  //  * @description get cities details
  //  */
  // citiesDetail: (citiesID?: number) =>
  //   `/v1/cities/${citiesID}`,
};
var citiesEndpoints = _objectSpread(_objectSpread({}, citiesDynamic), citiesStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/cities.request.ts


var getCities = function getCities(filters) {
  return (0,base_services_request/* getRequest */.A_)(citiesEndpoints.citiesList, filters).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
};
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./custom-hooks/use-cities.hook.ts




function useCities() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    q: ""
  };
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var haSH = JSON.stringify(getFilter(filters));
  return (0,useQuery/* useQuery */.a)(["citiesList", haSH], function () {
    return getCities(filters);
  }, {
    cacheTime: Infinity,
    staleTime: Infinity,
    select: function select(response) {
      return [{
        id: 1,
        description: "DISTRITO NACIONAL"
      }].concat((0,toConsumableArray/* default */.Z)(response.data));
    }
  });
}
var getFilter = (0,lodash.debounce)(function (e) {
  return e;
}, 200);

/***/ }),

/***/ 44231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90116);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61730);



function useWidth() {
  var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();

  var keys = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.keys).reverse();

  return keys.reduce(function (output, key) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || "xs";
}

/***/ }),

/***/ 64255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AdvanceFilterDialog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./shared/components/slide-transition/index.tsx
var slide_transition = __webpack_require__(97472);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(25662);
// EXTERNAL MODULE: ./shared/components/auto-complete-field/index.tsx + 2 modules
var auto_complete_field = __webpack_require__(69891);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 5 modules
var FormControlLabel = __webpack_require__(60856);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(79717);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/buttons-radio-group/index.tsx




var _excluded = ["name", "items", "useFormik", "values", "onChange"],
    _excluded2 = ["name", "items"],
    _excluded3 = ["items", "value", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var RadioButtonGroup = function RadioButtonGroup(props) {
  var name = props.name,
      items = props.items,
      _props$useFormik = props.useFormik,
      useFormik = _props$useFormik === void 0 ? true : _props$useFormik,
      _props$values = props.values,
      values = _props$values === void 0 ? null : _props$values,
      onChange = props.onChange,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  if (useFormik) {
    return /*#__PURE__*/react.createElement(RadioButtonGroupFormik, _objectSpread({
      name: name,
      items: items
    }, rest));
  } else {
    return /*#__PURE__*/react.createElement(RadioButtonGroupNoFormik, _objectSpread({
      value: values,
      onChange: onChange,
      items: items
    }, rest));
  }
};

/* harmony default export */ var buttons_radio_group = (RadioButtonGroup);

var RadioButtonGroupFormik = function RadioButtonGroupFormik(props) {
  var name = props.name,
      items = props.items,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

  var _useField = (0,formik_esm/* useField */.U$)(name),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  return (0,emotion_react_browser_esm/* jsx */.tZ)(FormControl/* default */.Z, (0,esm_extends/* default */.Z)({
    css: Styles.root
  }, rest), (0,emotion_react_browser_esm/* jsx */.tZ)(RadioGroup/* default */.Z, (0,esm_extends/* default */.Z)({
    row: true
  }, field), items.map(function (item, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
      className: field.value == item.value ? "active" : "",
      key: i,
      value: item.value,
      control: (0,emotion_react_browser_esm/* jsx */.tZ)(Radio/* default */.Z, null),
      label: item.label
    });
  })));
};

var RadioButtonGroupNoFormik = function RadioButtonGroupNoFormik(props) {
  var items = props.items,
      value = props.value,
      onChange = props.onChange,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded3);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(FormControl/* default */.Z, (0,esm_extends/* default */.Z)({
    css: Styles.root
  }, rest), (0,emotion_react_browser_esm/* jsx */.tZ)(RadioGroup/* default */.Z, {
    row: true,
    onChange: onChange
  }, items.map(function (item, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
      className: value == item.value ? "active" : "",
      key: i,
      value: item.value,
      control: (0,emotion_react_browser_esm/* jsx */.tZ)(Radio/* default */.Z, null),
      label: item.label
    });
  })));
};

var Styles = {
  root:  true ? {
    name: "c9sm7n",
    styles: "& .MuiFormGroup-root{display:flex;flex-wrap:nowrap;}& .MuiFormControlLabel-root{background-color:var(--color-brand-grey-secondary);color:white;padding:10px;min-width:85px;border-radius:25px;&.active{background-color:var(--color-brand-blue-main);}& .MuiRadio-root{display:none;text-align:center;}& .MuiFormControlLabel-label{width:100%;text-align:center;}}"
  } : 0
};
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RadioButtonChecked.js
var RadioButtonChecked = __webpack_require__(8857);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RadioButtonUnchecked.js
var RadioButtonUnchecked = __webpack_require__(59462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./shared/models/const/improvements.conts.ts
var improvements_conts = __webpack_require__(12930);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(53457);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./shared/components/checkbox-group-v2/index.tsx






function checkbox_group_v2_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CheckBoxGroupV2 = function CheckBoxGroupV2(props) {
  var _props$row;

  var _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? true : _props$multiple;

  var _useField = (0,formik_esm/* useField */.U$)({
    name: props.name
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var handleChange = function handleChange(event, checked) {
    if (checked) {
      if (!multiple) {
        helpers.setValue([event.target.value + ""]);
        return;
      }

      helpers.setValue([event.target.value + ""].concat((0,toConsumableArray/* default */.Z)(field.value)));
    } else {
      helpers.setValue((0,lodash.remove)(field.value, function (n) {
        return n != event.target.value;
      }));
    }
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(FormGroup/* default */.Z, {
    row: (_props$row = props.row) !== null && _props$row !== void 0 ? _props$row : true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentGroup, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      gridTemplateColumns: "repeat(" + props.column + ", 1fr)"
    },  true ? "" : 0,  true ? "" : 0)
  }, props.options.map(function (opt, i) {
    var _props$handleChange, _field$value;

    return (0,emotion_react_browser_esm/* jsx */.tZ)(ControlLabel, {
      style: !opt.textWrap ? {} : {
        whiteSpace: "nowrap"
      },
      name: props.name,
      key: i,
      control: (0,emotion_react_browser_esm/* jsx */.tZ)(ControlCheckBox, (0,esm_extends/* default */.Z)({
        name: props.name
      }, props.checkBoxProps, {
        onChange: (_props$handleChange = props.handleChange) !== null && _props$handleChange !== void 0 ? _props$handleChange : handleChange,
        value: opt.value,
        checked: (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.includes(opt.value + "")
      })),
      label: opt.label
    });
  })));
};

/* harmony default export */ var checkbox_group_v2 = (CheckBoxGroupV2);

var ControlCheckBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Checkbox/* default */.Z,  true ? {
  target: "ec26w92"
} : 0)(function (_ref) {
  var name = _ref.name;
  return name === "improvements" ? "\n  &.MuiButtonBase-root {\n    padding: 2px;\n    padding-right: 0;\n  }\n  " : null;
}, ";" + ( true ? "" : 0));

var ControlLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormControlLabel/* default */.Z,  true ? {
  target: "ec26w91"
} : 0)(".MuiFormControlLabel-label{font-weight:bold;font-size:", function (_ref2) {
  var name = _ref2.name;
  return name === "improvements" ? "12px" : "15px";
}, ";color:#000;font-family:var(--font-family);text-transform:capitalize;white-space:nowrap;}&.MuiFormControlLabel-root{margin-left:0;margin-right:0;margin-bottom:10px;}" + ( true ? "" : 0));

var ContentGroup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ec26w90"
} : 0)( true ? {
  name: "4pd713",
  styles: "display:grid;width:100%;grid-column-gap:5px"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./shared/components/accordion/index.tsx



function accordion_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function AccordionBase(props) {
  var _props$expandIcon;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isExpanded = _React$useState2[0],
      Expaded = _React$useState2[1];

  var handleToogleAccordion = (0,react.useCallback)(function () {
    Expaded(!isExpanded);

    if ((props === null || props === void 0 ? void 0 : props.isActiveAccordion) != undefined) {
      props === null || props === void 0 ? void 0 : props.isActiveAccordion(!isExpanded);
    }
  }, [isExpanded]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionCustom, {
    expanded: isExpanded
  }, !isExpanded && (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionSummaryCustom, {
    expandIcon: (_props$expandIcon = props.expandIcon) !== null && _props$expandIcon !== void 0 ? _props$expandIcon : false,
    "aria-controls": "panel1a-content",
    id: props.id
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionLabel, {
    onClick: handleToogleAccordion
  }, props.label)), (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionDetails/* default */.Z, null, props.children), (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionLabel, {
    onClick: handleToogleAccordion
  }, props.label)));
}

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8e5rap3"
} : 0)( true ? {
  name: "1ountk8",
  styles: "width:100%;display:inline-block"
} : 0);

var AccordionCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Accordion/* default */.Z,  true ? {
  target: "e8e5rap2"
} : 0)( true ? {
  name: "104yndh",
  styles: "background:transparent;box-shadow:none;padding:0px;& .MuiAccordionDetails-root{padding:0px;}"
} : 0);

var AccordionLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e8e5rap1"
} : 0)( true ? {
  name: "ihwyu1",
  styles: "display:block;text-align:center;color:var(--font-family);color:var(--color-brand-blue-main);font-weight:bold;width:100%;cursor:pointer"
} : 0);

var AccordionSummaryCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(AccordionSummary/* default */.Z,  true ? {
  target: "e8e5rap0"
} : 0)( true ? {
  name: "qx5wax",
  styles: "margin:16px 0px;&.MuiAccordionSummary-root{min-height:20px;height:20px;}width:100%;display:flex;justify-content:center;align-items:center"
} : 0);
;// CONCATENATED MODULE: ./shared/components/improvements-list/index.tsx










function ImprovementsList(props) {
  var CImprovements = (0,improvements_conts/* useIntlImprovements */.tH)();
  var canSee = CImprovements.slice(0, 18);
  var hidden = CImprovements.slice(18);

  var _useState = (0,react.useState)(false),
      accordion = _useState[0],
      isActiveAccordion = _useState[1];

  var translation = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");
  var ref = (0,react.useRef)();
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      m: "auto",
      mt: 4
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    hidden: accordion
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(checkbox_group_v2, {
    column: props.columns,
    options: canSee,
    name: "improvements",
    checkBoxProps: {
      icon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonUnchecked/* default */.Z, {
        sx: {
          color: "gray"
        }
      }),
      checkedIcon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonChecked/* default */.Z, {
        sx: {
          color: "var(--color-brand-green-main)"
        }
      })
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionBase, {
    id: "impro",
    label: !accordion ? translation("seeMore") : translation("seeLess"),
    isActiveAccordion: isActiveAccordion
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(checkbox_group_v2, {
    column: props.columns,
    options: CImprovements,
    name: "improvements",
    checkBoxProps: {
      icon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonUnchecked/* default */.Z, {
        sx: {
          color: "gray"
        }
      }),
      checkedIcon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonChecked/* default */.Z, {
        sx: {
          color: "var(--color-brand-green-main)"
        }
      })
    }
  }))));
}

/* harmony default export */ var improvements_list = (ImprovementsList);
// EXTERNAL MODULE: ./shared/components/text-field/index.tsx + 2 modules
var text_field = __webpack_require__(22900);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./shared/components/mask-components/index.tsx
var mask_components = __webpack_require__(95114);
// EXTERNAL MODULE: ./shared/models/const/property-types.ts
var property_types = __webpack_require__(86465);
// EXTERNAL MODULE: ./shared/components/switch-labels/formik-switch-labels.tsx
var formik_switch_labels = __webpack_require__(16447);
// EXTERNAL MODULE: ./shared/models/const/currencyTypes.ts
var currencyTypes = __webpack_require__(83479);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/util/form.util.ts
var FormRealEstateFormik = {
  initialValues: {
    amountMax: "",
    amountMin: "",
    bathrooms: 0,
    halfBathrooms: 0,
    bedrooms: 0,
    floorLevels: 0,
    parkings: 0,
    currencyType: "us",
    sector: [],
    // propertyStatus: ["1"],
    realEstateType: "",
    search: "",
    locations: [],
    typeProperty: [],
    improvements: []
  }
};
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./api/sector.request.ts + 1 modules
var sector_request = __webpack_require__(14788);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/desktop-form/SectorField.tsx




function SectorField_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var SectorsField = function SectorsField(_ref) {
  var name = _ref.name,
      cityId = _ref.cityId,
      _ref$limitTags = _ref.limitTags,
      limitTags = _ref$limitTags === void 0 ? 2 : _ref$limitTags,
      _ref$disableCloseOnSe = _ref.disableCloseOnSelect,
      disableCloseOnSelect = _ref$disableCloseOnSe === void 0 ? true : _ref$disableCloseOnSe;
  var t = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");

  var _useFormikContext = (0,formik_esm/* useFormikContext */.u6)(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue; // valor actual del campo en formik (arreglo)


  var value = Array.isArray((0,formik_esm/* getIn */.u9)(values, name)) ? (0,formik_esm/* getIn */.u9)(values, name) : [];

  var _React$useState = react.useState(""),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      search = _React$useState2[0],
      setSearch = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      isOpen = _React$useState4[0],
      setIsOpen = _React$useState4[1];

  var prevCityIdRef = react.useRef(null);
  var canFetch = react.useMemo(function () {
    return !!cityId && (search.trim().length === 0 || search.trim().length > 2);
  }, [cityId, search]);

  var _useQuery = (0,useQuery/* useQuery */.a)(["sectors-by-city", cityId, search], function () {
    return (0,sector_request/* getSector */.s)({
      q: search,
      limit: 10,
      cityId: cityId
    });
  }, {
    enabled: canFetch,
    keepPreviousData: false
  }),
      data = _useQuery.data,
      isFetching = _useQuery.isFetching,
      dataUpdatedAt = _useQuery.dataUpdatedAt;

  var options = react.useMemo(function () {
    if (!cityId || !canFetch) return [];
    if (!(data !== null && data !== void 0 && data.data)) return [];
    return adapterSectors(data.data);
  }, [cityId, canFetch, data === null || data === void 0 ? void 0 : data.data, dataUpdatedAt]); // Cuando cambia la ciudad, limpiar campo y opciones si aplica

  react.useEffect(function () {
    var prevCityId = prevCityIdRef.current;

    if (!cityId) {
      if (value.length) setFieldValue(name, []);
      setSearch("");
    } else if (prevCityId && prevCityId !== cityId) {
      if (value.length) setFieldValue(name, []);
      setSearch("");
    }

    prevCityIdRef.current = cityId;
  }, [cityId, value.length, name, setFieldValue]);
  var handleInputChange = react.useCallback(function (_event, newValue, reason) {
    if (reason === "clear" || reason === "reset") {
      setSearch("");
      return;
    }

    if (reason === "input") {
      setSearch(newValue !== null && newValue !== void 0 ? newValue : "");
    }
  }, []);

  var handleChange = function handleChange(_event, newValue) {
    setFieldValue(name, newValue !== null && newValue !== void 0 ? newValue : []);
  };

  var renderTags = react.useCallback(function (selected, getTagProps) {
    if (isOpen || search.trim().length > 0) {
      return null;
    }

    var limit = typeof limitTags === "number" ? limitTags : selected.length;
    var visible = selected.slice(0, limit);
    var hiddenCount = selected.length - visible.length;
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, visible.map(function (option, index) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(TagChip, (0,esm_extends/* default */.Z)({}, getTagProps({
        index: index
      }), {
        key: option.id,
        label: option.description,
        size: "small",
        title: option.description
      }));
    }), hiddenCount > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(TagChip, {
      key: "more-tags",
      label: "+".concat(hiddenCount),
      size: "small",
      disabled: true
    }));
  }, [isOpen, limitTags, search]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledAutoComplete, {
    name: name,
    multiple: true,
    limitTags: limitTags,
    options: options,
    value: value,
    onChange: handleChange,
    onInputChange: handleInputChange,
    getOptionLabel: function getOptionLabel(opt) {
      var _opt$description;

      return (_opt$description = opt === null || opt === void 0 ? void 0 : opt.description) !== null && _opt$description !== void 0 ? _opt$description : "";
    },
    placeholder: t("sector"),
    disabled: !cityId,
    loading: isFetching,
    disableCloseOnSelect: disableCloseOnSelect,
    renderTags: renderTags,
    onOpen: function onOpen() {
      return setIsOpen(true);
    },
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }), !cityId && (0,emotion_react_browser_esm/* jsx */.tZ)(SectorHelperText, null, t("sectorCityHint")));
};
/** Helpers */

var adapterSectors = function adapterSectors() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return rows.map(function (r) {
    return {
      id: r.id,
      description: r.description,
      city_id: r.city_id
    };
  });
};

var TagChip = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Chip/* default */.Z,  true ? {
  target: "e7wkduo2"
} : 0)( true ? {
  name: "1oydtrn",
  styles: "max-width:100px;height:26px;& .MuiChip-label{display:block;max-width:100px;overflow:hidden;text-overflow:ellipsis;}"
} : 0);

var StyledAutoComplete = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(auto_complete_field/* default */.Z,  true ? {
  target: "e7wkduo1"
} : 0)( true ? {
  name: "1shf049",
  styles: "fieldset{border-radius:50px;}.MuiAutocomplete-inputRoot{min-height:46px;flex-wrap:nowrap;align-items:center;padding-top:4px!important;padding-bottom:4px!important;}.MuiAutocomplete-tag{margin:0 4px 0 0;}input::placeholder{color:#000;opacity:1;font-weight:600;font-size:14px;padding-left:10px;}"
} : 0);

var SectorHelperText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e7wkduo0"
} : 0)( true ? {
  name: "m2zrhj",
  styles: "display:block;font-size:10px;margin-top:4px"
} : 0);

/* harmony default export */ var SectorField = (SectorsField);
// EXTERNAL MODULE: ./custom-hooks/use-cities.hook.ts + 2 modules
var use_cities_hook = __webpack_require__(78647);
// EXTERNAL MODULE: ./shared/models/functions/cities.helper.ts
var cities_helper = __webpack_require__(75769);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/desktop-form/CityField.tsx




function CityField_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var CitiesField = function CitiesField(_ref) {
  var name = _ref.name,
      _ref$limitTags = _ref.limitTags,
      limitTags = _ref$limitTags === void 0 ? 2 : _ref$limitTags,
      _ref$disableCloseOnSe = _ref.disableCloseOnSelect,
      disableCloseOnSelect = _ref$disableCloseOnSe === void 0 ? true : _ref$disableCloseOnSe;
  var t = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");

  var _useFormikContext = (0,formik_esm/* useFormikContext */.u6)(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var value = Array.isArray((0,formik_esm/* getIn */.u9)(values, name)) ? (0,formik_esm/* getIn */.u9)(values, name) : [];

  var _React$useState = react.useState(""),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      search = _React$useState2[0],
      setSearch = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      isOpen = _React$useState4[0],
      setIsOpen = _React$useState4[1];

  var _useCities = (0,use_cities_hook/* default */.Z)({
    q: search
  }),
      data = _useCities.data,
      isLoading = _useCities.isLoading;

  var options = react.useMemo(function () {
    return data ? (0,cities_helper/* default */.Z)(data) : [];
  }, [data]);
  var handleInputChange = react.useCallback(function (_event, newValue, reason) {
    if (reason === "clear" || reason === "reset") {
      setSearch("");
      return;
    }

    if (reason === "input") {
      setSearch(newValue !== null && newValue !== void 0 ? newValue : "");
    }
  }, []);
  var handleChange = react.useCallback(function (_event, newValue) {
    var lastOption = newValue === null || newValue === void 0 ? void 0 : newValue[newValue.length - 1];
    setFieldValue(name, lastOption ? [lastOption] : []);
  }, [name, setFieldValue]);
  var renderTags = react.useCallback(function (selected, getTagProps) {
    if (isOpen || search.trim().length > 0) {
      return null;
    }

    var limit = typeof limitTags === "number" ? limitTags : selected.length;
    var visible = selected.slice(0, limit);
    var hiddenCount = selected.length - visible.length;
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, visible.map(function (option, index) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(CityField_TagChip, (0,esm_extends/* default */.Z)({}, getTagProps({
        index: index
      }), {
        key: option.id,
        label: option.description,
        size: "small",
        title: option.description
      }));
    }), hiddenCount > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(CityField_TagChip, {
      key: "more-tags",
      label: "+".concat(hiddenCount),
      size: "small",
      disabled: true
    }));
  }, [isOpen, limitTags, search]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(CityField_StyledAutoComplete, {
    name: name,
    multiple: true,
    limitTags: limitTags,
    options: options,
    value: value,
    onChange: handleChange,
    onInputChange: handleInputChange,
    getOptionLabel: function getOptionLabel(option) {
      var _option$description;

      return (_option$description = option === null || option === void 0 ? void 0 : option.description) !== null && _option$description !== void 0 ? _option$description : "";
    },
    placeholder: t("city"),
    loading: isLoading,
    renderTags: renderTags,
    onOpen: function onOpen() {
      return setIsOpen(true);
    },
    onClose: function onClose() {
      return setIsOpen(false);
    } // disableCloseOnSelect={disableCloseOnSelect}

  });
};

var CityField_TagChip = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Chip/* default */.Z,  true ? {
  target: "e1n9sj781"
} : 0)( true ? {
  name: "1oydtrn",
  styles: "max-width:100px;height:26px;& .MuiChip-label{display:block;max-width:100px;overflow:hidden;text-overflow:ellipsis;}"
} : 0);

var CityField_StyledAutoComplete = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(auto_complete_field/* AutoCompleteField */.K,  true ? {
  target: "e1n9sj780"
} : 0)( true ? {
  name: "1shf049",
  styles: "fieldset{border-radius:50px;}.MuiAutocomplete-inputRoot{min-height:46px;flex-wrap:nowrap;align-items:center;padding-top:4px!important;padding-bottom:4px!important;}.MuiAutocomplete-tag{margin:0 4px 0 0;}input::placeholder{color:#000;opacity:1;font-weight:600;font-size:14px;padding-left:10px;}"
} : 0);

/* harmony default export */ var CityField = (CitiesField);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/desktop-form/index.tsx



function desktop_form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function desktop_form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? desktop_form_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : desktop_form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function desktop_form_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






















var DesktopForm = function DesktopForm(props) {
  var _values$locations, _values$locations$;

  var width = (0,use_width_hook/* useWidth */.z)();
  var isMobile = ["xs", "sm"].includes(width);
  var translations = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");
  var CPropertyTypes = (0,property_types/* useIntlPropertyTypes */.Pb)();
  var ctxF = (0,formik_esm/* useFormikContext */.u6)();
  var values = ctxF.values;
  var cityIdRaw = values === null || values === void 0 ? void 0 : (_values$locations = values.locations) === null || _values$locations === void 0 ? void 0 : (_values$locations$ = _values$locations[0]) === null || _values$locations$ === void 0 ? void 0 : _values$locations$.id;
  var cityId = cityIdRaw ? Number(cityIdRaw) : null;
  var amountMin = values === null || values === void 0 ? void 0 : values.amountMin;
  var amountMax = values === null || values === void 0 ? void 0 : values.amountMax;
  var priceRangeInvalid = react.useMemo(function () {
    if (!amountMin || !amountMax) return false;
    var min = Number(amountMin);
    var max = Number(amountMax);
    if (Number.isNaN(min) || Number.isNaN(max)) return false;
    return max < min;
  }, [amountMin, amountMax]);

  var handleSubmit = function handleSubmit() {
    props.handleToggleModal();
    setTimeout(function () {
      props.handleSubmit();
    }, 500);
  };

  var handleReset = function handleReset() {
    props.handleToggleModal();
    setTimeout(function () {
      ctxF.setValues(desktop_form_objectSpread(desktop_form_objectSpread({}, FormRealEstateFormik.initialValues), {}, {
        bathrooms: null,
        halfBathrooms: null,
        bedrooms: null,
        floorLevels: null,
        parkings: null
      }));
      props.handleReset();
    }, 500);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledWrapper, {
    className: "p-15"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    item: true,
    xs: 12,
    spacing: 1,
    className: "m-t-5 m-b-20"
  }, isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledCustomAutoComp, {
    name: "typeProperty",
    limitTags: 1,
    multiple: true,
    getOptionLabel: function getOptionLabel(option) {
      return option === null || option === void 0 ? void 0 : option.name;
    },
    placeholder: translations("typePlaceholder"),
    options: CPropertyTypes,
    className: "typeProperty-autocomplete"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null))), (0,emotion_react_browser_esm/* jsx */.tZ)(checkbox_group_v2, {
    column: 3,
    options: [{
      label: translations("underConstruction"),
      value: false
    }, {
      label: translations("built"),
      value: true
    }],
    name: "onlyUnits",
    checkBoxProps: {
      icon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonUnchecked/* default */.Z, {
        sx: {
          color: "gray"
        }
      }),
      checkedIcon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonChecked/* default */.Z, {
        sx: {
          color: "var(--color-brand-green-main)"
        }
      })
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      marginTop: "15px"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(checkbox_group_v2, {
    column: 3,
    options: [{
      label: translations("furnished"),
      value: 1
    }, {
      label: translations("whiteLine"),
      value: 2
    }],
    multiple: false,
    name: "extraBusinessTypes",
    checkBoxProps: {
      icon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonUnchecked/* default */.Z, {
        sx: {
          color: "gray"
        }
      }),
      checkedIcon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonChecked/* default */.Z, {
        sx: {
          color: "var(--color-brand-green-main)"
        }
      })
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 3,
    className: "p-t-15"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    sm: 4,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("baths"),
    name: "bathrooms",
    inputComponent: mask_components/* NumberInput */.Y2
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    sm: 4,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(HalfBatRoom, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    sm: 4,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BedRoom, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    sm: 4,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("parkings"),
    name: "parkings",
    inputComponent: mask_components/* NumberInput */.Y2
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    sm: 4,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("level"),
    inputComponent: mask_components/* NumberInput */.Y2,
    name: "floorLevels"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(LocationRow, null, (0,emotion_react_browser_esm/* jsx */.tZ)(LocationField, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CityField, {
    name: "locations",
    limitTags: 1
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LocationField, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SectorField, {
    name: "sector",
    cityId: cityId,
    limitTags: 1
  }))))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 3,
    className: "p-t-15",
    alignItems: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SectionLabel, null, translations("price"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CurrencySelector, null, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_switch_labels/* default */.Z, {
    options: currencyTypes/* CCurrencyTypes */.v,
    name: "currencyType"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("minimum"),
    name: "amountMin",
    inputComponent: mask_components/* MoneyInput */.PK
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("maximum"),
    name: "amountMax",
    inputComponent: mask_components/* MoneyInput */.PK
  })), priceRangeInvalid && (0,emotion_react_browser_esm/* jsx */.tZ)(PriceError, null, translations("price_range-error_message"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    style: {
      width: "100%",
      margin: "auto"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(improvements_list, {
    columns: 3
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyContent: "space-around",
    className: "p-v-15 fixed-bottom b-0",
    alignItems: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DeleteButton, {
    variant: "text",
    onClick: handleReset,
    sx: {
      color: "var(--color-brand-blue-main)"
    }
  }, translations("delete")), (0,emotion_react_browser_esm/* jsx */.tZ)(Button_Button/* default */.Z, {
    onClick: handleSubmit,
    sx: {
      background: "var(--color-brand-red-secondary)",
      color: "white",
      borderRadius: 10,
      fontSize: 12,
      px: 4,
      height: 35 // py:-4

    }
  }, translations("apply"))));
};

var Sector = function Sector() {
  return;
};

var BedRoom = function BedRoom() {
  var _useFormikContext = (0,formik_esm/* useFormikContext */.u6)(),
      setFieldValue = _useFormikContext.setFieldValue,
      values = _useFormikContext.values;

  var _useState = (0,react.useState)(),
      value = _useState[0],
      setValues = _useState[1];

  var translations = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");

  var changeBedroom = function changeBedroom(e) {
    var value = e.target.value; // Solo acepta números (enteros o decimales)

    var numericValue = value.replace(/[^0-9]/g, ""); // Opcional: convertir a número

    var numberValue = numericValue ? Number(numericValue) : "";
    setFieldValue("bedrooms", numberValue);
    setValues(numberValue);
  };

  (0,react.useEffect)(function () {
    var _values$bedrooms;

    if (typeof values.bedrooms == "number") {
      setValues(values.bedrooms);
    }

    if (Array.isArray(values.bedrooms) && values !== null && values !== void 0 && (_values$bedrooms = values.bedrooms) !== null && _values$bedrooms !== void 0 && _values$bedrooms.length) {
      setValues(Number(values.bedrooms[0]));
    }
  }, []);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("bedrooms"),
    name: "bedrooms",
    onChange: changeBedroom,
    value: value
  });
};

var HalfBatRoom = function HalfBatRoom() {
  var _useFormikContext2 = (0,formik_esm/* useFormikContext */.u6)(),
      setFieldValue = _useFormikContext2.setFieldValue,
      values = _useFormikContext2.values;

  var _useState2 = (0,react.useState)(),
      value = _useState2[0],
      setValues = _useState2[1];

  var translations = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");

  var changeHalfBatRoom = function changeHalfBatRoom(e) {
    var value = e.target.value; // Solo acepta números (enteros o decimales)

    var numericValue = value.replace(/[^0-9]/g, ""); // Opcional: convertir a número

    var numberValue = numericValue ? Number(numericValue) : "";
    setFieldValue("halfBathrooms", numberValue);
    setValues(numberValue);
  };

  (0,react.useEffect)(function () {
    var _values$halfBathrooms;

    if (typeof values.halfBathrooms == "number") {
      setValues(values.halfBathrooms);
    }

    if (Array.isArray(values.halfBathrooms) && values !== null && values !== void 0 && (_values$halfBathrooms = values.halfBathrooms) !== null && _values$halfBathrooms !== void 0 && _values$halfBathrooms.length) {
      setValues(Number(values.halfBathrooms[0]));
    }
  }, []);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* default */.Z, {
    placeholder: translations("half_baths"),
    name: "halfBathrooms",
    onChange: changeHalfBatRoom,
    value: value
  });
};

var StyledWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exbum6o9"
} : 0)( true ? {
  name: "12wcffj",
  styles: ".MuiInputBase-input{&::placeholder{color:#737373;font-weight:400;font-size:14px;padding-left:10px;}}"
} : 0);

var LocationRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exbum6o8"
} : 0)( true ? {
  name: "1a5gun7",
  styles: "display:flex;gap:15px;align-items:flex-start;width:100%"
} : 0);

var LocationField = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exbum6o7"
} : 0)( true ? {
  name: "1j1nxks",
  styles: "flex:1;.MuiAutocomplete-root{width:100%;}"
} : 0);

var desktop_form_adapterSectors = function adapterSectors() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return data.map(function (item) {
    return {
      id: item.id,
      description: item.description,
      city_id: item.city_id
    };
  });
};

var PriceContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exbum6o6"
} : 0)( true ? {
  name: "1c3pogw",
  styles: "display:flex;flex-direction:column;gap:10px"
} : 0);

var SectionLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "exbum6o5"
} : 0)( true ? {
  name: "481o6d",
  styles: "font-size:15px;font-weight:600;color:var(--color-brand-blue-main)"
} : 0);

var CurrencySelector = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exbum6o4"
} : 0)( true ? {
  name: "cl7urv",
  styles: "display:flex;flex-wrap:wrap;gap:8px"
} : 0);

var PriceError = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "exbum6o3"
} : 0)( true ? {
  name: "1pnybp9",
  styles: "font-size:0.8125rem;color:var(--color-brand-red-secondary);font-weight:500"
} : 0);

var DeleteButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button_Button/* default */.Z,  true ? {
  target: "exbum6o2"
} : 0)( true ? {
  name: "1s7ftfo",
  styles: "text-decoration:underline;font-weight:700;font-size:11px;padding-top:20px;@media screen and (max-width: 475px){margin-left:0;margin-top:15px;}"
} : 0);

var StyledRadioGroup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_radio_group,  true ? {
  target: "exbum6o1"
} : 0)( true ? {
  name: "vnfy02",
  styles: "& .MuiFormControlLabel-root{padding-left:20px;padding-right:20px;}"
} : 0);

var StyledCustomAutoComp = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(auto_complete_field/* default */.Z,  true ? {
  target: "exbum6o0"
} : 0)( true ? {
  name: "11b7rsr",
  styles: "fieldset{border-radius:50px;}input::placeholder{color:#000;opacity:1;font-weight:600;font-size:14px;padding-left:10px;}"
} : 0); // remove before tree weeks
// const styledAmount = {
//   xl: 4,
//   lg: 4,
//   md: 4,
//   sm: 6,
//   xs: 12,
//   sx: { marginTop: "26px" },
// };
// {
//   /* <Grid container sx={{ paddingY: 2 }} alignItems={"center"} spacing={1}>
//         <Grid container item xs={4}>
//           <LabelField label={translations("currency")} />
//           <Grid item xs={12} className="p-t-5 p-l-5">
//             <RadioButtonGroup name="currencyType" items={CCurrencyTypes} />
//           </Grid>
//         </Grid>
//         <Grid item {...styledAmount}>
//           <TextField
//             placeholder={translations("minimum")}
//             inputComponent={MoneyInput}
//             name="amountMin"
//           ></TextField>
//         </Grid>
//         <Grid item {...styledAmount}>
//           <TextField
//             inputComponent={MoneyInput}
//             placeholder={translations("maximum")}
//             name="amountMax"
//           ></TextField>
//         </Grid>
//       </Grid> */
// }
// {
//   /* <Divider />
//       <Grid
//         container
//         alignItems="center"
//         sx={{ paddingTop: "15px", paddingBottom: "25px" }}
//       >
//         <LabelField label="Quiero" />
//         <Grid item className="p-t-5 p-l-5">
//           <StyledRadioGroup name="businessTypes" items={itemsBusiness} />
//         </Grid>
//       </Grid>
//       <Divider /> */
// }
// {
//   /* <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
//           <TextField
//             placeholder={translations("bedrooms")}
//             name="bedrooms"
//             inputComponent={NumberInput}
//           ></TextField>
//         </Grid> */
// }
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AddOutlined.js
var AddOutlined = __webpack_require__(4431);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RemoveOutlined.js
var RemoveOutlined = __webpack_require__(89825);
;// CONCATENATED MODULE: ./shared/components/ButtonTypesField/index.tsx



function ButtonTypesField_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function ButtonTypesField(props) {
  var _useField = (0,formik_esm/* useField */.U$)({
    name: props.name
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var add = function add() {
    helpers.setValue(+field.value + 1);
  };

  var reduce = function reduce() {
    helpers.setValue(+field.value - 1);
  };

  var getVALUE = function getVALUE() {
    if (field.value === null || field.value === undefined || field.value === "" || field.value && field.value.length === 0) {
      return 0;
    } else {
      return field.value;
    }
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    alignItems: "center",
    justifyContent: "space-between"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, null, props.label), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonToggle, {
    color: "primary",
    disabled: field.value == 0 || field.value == null,
    onClick: reduce
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(RemoveOutlined/* default */.Z, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(LabelValue, null, getVALUE()), (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonToggle, {
    color: "primary",
    onClick: add
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(AddOutlined/* default */.Z, null))));
}

/* harmony default export */ var components_ButtonTypesField = (ButtonTypesField);

var ButtonToggle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconButton/* default */.Z,  true ? {
  target: "e1fgvu502"
} : 0)( true ? {
  name: "1fs2oks",
  styles: "border:3px solid var(--color-brand-blue-main);padding:3px;margin:2px 8px;&.Mui-disabled{border:3px solid gray;}"
} : 0);

var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e1fgvu501"
} : 0)( true ? {
  name: "481o6d",
  styles: "font-size:15px;font-weight:600;color:var(--color-brand-blue-main)"
} : 0);

var LabelValue = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1fgvu500"
} : 0)( true ? {
  name: "adcapw",
  styles: "font-size:15px;font-weight:600;margin:0px 15px;display:inline-block;width:10px;color:var(--color-brand-blue-main)"
} : 0);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/models/const/businessTypes.ts
var businessTypes = __webpack_require__(80074);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./node_modules/@mui/base/useAutocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__(93362);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/autocompleteClasses.js
var autocompleteClasses = __webpack_require__(80482);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/mobile-form/auto-complete-field/index.tsx




var _templateObject;










function FilterAutoComplete(props) {
  var _props$INPUT_DELAY;

  var _React$useState = react.useState(""),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      valueInput = _React$useState2[0],
      setInputValue = _React$useState2[1];

  var _useField = (0,formik_esm/* useField */.U$)({
    name: props.name
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var handleChange = function handleChange(_, value) {
    if (value != null) {
      props.multiple ? helpers.setValue(value) : helpers.setValue([value.length > 1 ? value[1] : value[0]]);
    }
  };

  var onChangeInputValue = function onChangeInputValue(e, value) {
    setInputValue(value);
    debounceHandler(e, value);
  };

  var debounceHandler = (0,react.useCallback)((0,lodash.debounce)(function (event, inputValue) {
    onInputValue(event, inputValue);
  }, (_props$INPUT_DELAY = props.INPUT_DELAY) !== null && _props$INPUT_DELAY !== void 0 ? _props$INPUT_DELAY : 500), []);

  var onInputValue = function onInputValue(e, value) {
    if (props !== null && props !== void 0 && props.onInput && value != "undefined" && value != undefined) {
      props === null || props === void 0 ? void 0 : props.onInput(value);
    }
  }; // temporal fixed {load information from url }


  if (props.name == "typeProperty" && typeof field.value[0] == "string") {
    helpers.setValue(props.data.filter(function (x) {
      return field.value.includes(x["slug"]);
    }));
  }

  var _useAutocomplete = (0,useAutocomplete/* useAutocomplete */.o)({
    id: props.name,
    multiple: true,
    options: props.data,
    openOnFocus: true,
    disabled: props.disabled,
    onChange: handleChange,
    value: field.value,
    onInputChange: onChangeInputValue,
    inputValue: valueInput == "undefined" ? "" : valueInput,
    onClose: function onClose() {
      setInputValue("");
    },
    getOptionLabel: function getOptionLabel(option) {
      return option === null || option === void 0 ? void 0 : option.description;
    }
  }),
      getRootProps = _useAutocomplete.getRootProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getInputProps = _useAutocomplete.getInputProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      groupedOptions = _useAutocomplete.groupedOptions,
      focused = _useAutocomplete.focused,
      setAnchorEl = _useAutocomplete.setAnchorEl;

  var clearField = function clearField() {
    helpers.setValue([]);

    if (props.onInput != undefined) {
      props.onInput("");
    }
  };

  var text = getInputProps().value;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Root, null, valueInput == "undefined" + "", (0,emotion_react_browser_esm/* jsx */.tZ)(WrapperContentComponent, getRootProps(), (0,emotion_react_browser_esm/* jsx */.tZ)(InputWrapper, {
    ref: setAnchorEl,
    className: focused ? "focused" : ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(auto_complete_field_Label, getInputLabelProps(), props.label), (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({}, getInputProps(), {
    disabled: props.disabled,
    name: props.name,
    value: valueInput !== null && valueInput !== void 0 ? valueInput : ""
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(SearchIconBlue, null)), text.length < 3 && focused && props.showMessageMin && (0,emotion_react_browser_esm/* jsx */.tZ)(MessageSearch, null, "Escribe 3 o mas letras para buscar"), (field === null || field === void 0 ? void 0 : field.value) != null && "map" in field.value && field.value.map(function (option, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledTag, (0,esm_extends/* default */.Z)({}, getTagProps({
      index: index
    }), {
      key: index,
      label: option === null || option === void 0 ? void 0 : option.description,
      onDelete: props.multiple ? getTagProps({
        index: index
      }).onDelete : clearField
    }));
  }), (groupedOptions === null || groupedOptions === void 0 ? void 0 : groupedOptions.length) > 0 ? (0,emotion_react_browser_esm/* jsx */.tZ)(Listbox, getListboxProps(), groupedOptions.map(function (option, index) {
    var _field$value, _field$value$map;

    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, !(field !== null && field !== void 0 && (_field$value = field.value) !== null && _field$value !== void 0 && (_field$value$map = _field$value.map(function (x) {
      return x.id;
    })) !== null && _field$value$map !== void 0 && _field$value$map.includes(option.id)) && (0,emotion_react_browser_esm/* jsx */.tZ)("li", (0,esm_extends/* default */.Z)({}, getOptionProps({
      option: option,
      index: index
    }), {
      key: index
    }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, option === null || option === void 0 ? void 0 : option.description)), (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null));
  })) : null);
}
var Root = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return "\n    width:100%;\n    display: block;\n    padding:10px 0;\n";
});
var WrapperContentComponent = (0,styled/* default */.ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return "\n    background:#fff;\n    height:75px; \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border-radius:30px;\n    overflow: hidden;\n    padding:10px 20px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    margin-bottom:5px;\n";
});
var MessageSearch = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return "\n  background-color:white;\n  padding:10px;\n  border-radius:8px;\n  color:var(--color-brand-blue-main);\n  font-size:14px;\n  font-weight:700; \n  width:97%;\n  margin:auto;\n";
});
var StyledTag = (0,styled/* default */.ZP)(Chip/* default */.Z)(function (_ref4) {
  var theme = _ref4.theme;
  return "\n  background-color:var(--color-brand-blue-main);\n    color:white;\n    margin:1px 2px;\n  & svg {\n    fill:white; \n  }\n";
});
var auto_complete_field_Label = (0,styled/* default */.ZP)("label")(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 1.5;\n  display: block;\n  color: var(--color-brand-grey-quaternary);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  max-width: 160px;\n  min-width: fit-content;\n  padding: 0px 8px;\n"])));
var InputWrapper = (0,styled/* default */.ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return "\n  width: 100%;\n  // max-width:300px;\n  min-width:150px;\n  background-color: #fff;\n  display: flex;\n  flex-wrap: wrap;\n  & input {\n    background-color: #fff;\n    color: var(--color-brand-blue-main);\n    box-sizing: border-box;\n    padding: 4px 6px;\n    width: 0;\n    min-width: 30px;\n    flex-grow: 1;\n    border: 0;\n    margin: 0;\n    outline: 0;\n    font-size: 16px;\n    font-weight: 600;\n  }\n";
});
var Listbox = (0,styled/* default */.ZP)("ul")(function (_ref6) {
  var theme = _ref6.theme;
  return "\n   width: 100%;\n  margin: 2px 0 0;\n  padding: 0 15px;\n  list-style: none;\n  background-color: ".concat(theme.palette.mode === "dark" ? "#141414" : "#fff", ";\n  overflow: auto;\n  max-height: 250px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n\n  & li {\n    padding: 15px 12px;\n    display: flex;\n\n\n    & span {\n      flex-grow: 1;\n      font-size:14px;\n      font-weight:600;\n    color:gray;\n    }\n\n    & svg {\n      color: transparent;\n    }\n  }\n\n  & li[aria-selected='true'] {\n    // background-color: ;\n    color:var(--color-brand-blue-main);\n    font-weight: 600;\n\n    & svg {\n      color: #1890ff;\n    }\n  }\n\n  & li.").concat(autocompleteClasses/* default.focused */.Z.focused, " {\n    background-color: ").concat(theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff", ";\n    cursor: pointer;\n\n    & svg {\n      color: currentColor;\n    }\n  }\n");
});
var SearchIconBlue = (0,styled/* default */.ZP)(Search/* default */.Z)(function (_ref7) {
  var theme = _ref7.theme;
  return "\n   color: var(--color-brand-grey-quaternary);\n   font-size: 27px;\n  ";
});
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/mobile-form/cities-field/index.tsx







function cities_field_CitiesField() {
  var _useState = (0,react.useState)(""),
      search = _useState[0],
      onSearch = _useState[1];

  var t = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter");

  var _useCities = (0,use_cities_hook/* default */.Z)(),
      data = _useCities.data;

  var items = data ? (0,cities_helper/* default */.Z)(data) : [];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(FilterAutoComplete, {
    data: items,
    id: "locations",
    name: "locations",
    multiple: false,
    showMessageMin: true,
    label: t("locationMobile"),
    onInput: function onInput(e) {
      return onSearch(e);
    }
  });
}

/* harmony default export */ var cities_field = (cities_field_CitiesField);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/components/message-modal/index.tsx
var message_modal = __webpack_require__(36481);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/mobile-form/code-search-field/index.tsx



function code_search_field_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function code_search_field_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? code_search_field_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : code_search_field_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function code_search_field_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var schema = es/* object */.Ry().shape({
  code: es/* number */.Rx().nullable()
});

var FormCodeSearch = function FormCodeSearch() {
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var isCollection = router.asPath.includes(pages_path/* CPagesPath.es.collection */.K.es.collection);
  var translationNotFound = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter.notFound");
  var translations = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");
  var propertyDetailRedirect = isCollection ? pages_path/* CPagesPath.es.collection_property_detail */.K.es.collection_property_detail : pages_path/* CPagesPath.es.property_detail */.K.es.property_detail;

  var handleToggleModal = function handleToggleModal() {
    setOpen(!open);
  };

  var getRealestateRequest = (0,useMutation/* useMutation */.D)(["detail-realstate"], function (realestateId) {
    return (0,realestate_request/* getRealestateDetails */.mW)(realestateId);
  });
  var form = {
    initialValues: {
      code: null
    },
    onSubmit: function onSubmit(e) {
      getRealestateRequest.mutateAsync(e.code).then(function (r) {
        router.push({
          pathname: propertyDetailRedirect(r.data),
          query: code_search_field_objectSpread({}, router.query)
        });
      })["catch"](function () {
        return handleToggleModal();
      });
    },
    validationSchema: schema
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(AccordionBase, {
    label: (0,emotion_react_browser_esm/* jsx */.tZ)(TextAccordion, null, "Buscar por c\xF3digo"),
    id: "form-code"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, form, function (props) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      component: formik_esm/* Form */.l0,
      container: true,
      item: true,
      xs: 12,
      justifyContent: "space-between",
      alignItems: "center",
      sx: {
        marginTop: 2,
        marginBottom: 3
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 8
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(TextFieldCode, {
      inputComponent: mask_components/* NumberInput */.Y2,
      placeholder: translations("code"),
      name: "code",
      id: "code"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerSearchButtonIcon, {
      item: true,
      xs: 4,
      sx: {
        mt: 1
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonSearch, {
      loading: getRealestateRequest.isLoading,
      variant: "contained",
      type: "button",
      onClick: function onClick() {
        return props.handleSubmit();
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(SearchButtonIcon, null))), (0,emotion_react_browser_esm/* jsx */.tZ)(message_modal/* ModalMessage */.P, {
      title: translationNotFound("title"),
      body: translationNotFound("body"),
      variant: "error",
      open: open,
      handleClose: handleToggleModal
    }));
  }));
};

/* harmony default export */ var code_search_field = (FormCodeSearch);

var TextAccordion = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1utw8sz4"
} : 0)( true ? {
  name: "1wbll7q",
  styles: "text-decoration:underline"
} : 0);

var SearchButtonIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Search/* default */.Z,  true ? {
  target: "e1utw8sz3"
} : 0)( true ? {
  name: "xbn1y0",
  styles: "color:white;font-size:26px"
} : 0);

var ButtonSearch = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LoadingButton/* default */.Z,  true ? {
  target: "e1utw8sz2"
} : 0)( true ? {
  name: "vz6gc2",
  styles: "color:white;font-size:26px;background:var(--color-brand-blue-main);width:80%;height:55px;border-radius:50px"
} : 0);

var ContainerSearchButtonIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Grid/* default */.ZP,  true ? {
  target: "e1utw8sz1"
} : 0)( true ? {
  name: "1vcob1d",
  styles: "display:flex;justify-content:center;align-items:center"
} : 0);

var TextFieldCustomShared =  true ? {
  name: "1il269v",
  styles: "background-color:white;padding:20px;border-radius:30px;border:0px solid transparent;box-shadow:rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;& input::placeholder{color:gray;}&*{outline:none;}"
} : 0;

var TextFieldCode = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(text_field/* default */.Z,  true ? {
  target: "e1utw8sz0"
} : 0)(TextFieldCustomShared, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/mobile-form/sector-field/index.tsx







var SectorsRequest = function SectorsRequest(filters) {
  return (0,sector_request/* getSector */.s)({
    q: filters.search == "" ? "" : filters.search,
    limit: 10,
    cityId: filters.citieID
  });
};

function sector_field_SectorsField() {
  var _ref, _c$values, _c$values$locations$, _data$data;

  var c = (0,formik_esm/* useFormikContext */.u6)();

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      onSearch = _useState[1];

  var citieID = (_ref = c === null || c === void 0 ? void 0 : (_c$values = c.values) === null || _c$values === void 0 ? void 0 : (_c$values$locations$ = _c$values.locations[0]) === null || _c$values$locations$ === void 0 ? void 0 : _c$values$locations$.id) !== null && _ref !== void 0 ? _ref : null;

  var _useMutation = (0,useMutation/* useMutation */.D)(["sectorsList"], SectorsRequest),
      mutate = _useMutation.mutate,
      data = _useMutation.data;

  (0,react.useEffect)(function () {
    if ((search === null || search === void 0 ? void 0 : search.length) > 2) mutate({
      search: search,
      citieID: citieID
    });
  }, [search]);
  var items = (search === null || search === void 0 ? void 0 : search.length) > 2 ? sector_field_adapterSectors((_data$data = data === null || data === void 0 ? void 0 : data.data) !== null && _data$data !== void 0 ? _data$data : []) : [];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(FilterAutoComplete, {
    id: "sector",
    data: items,
    name: "sector",
    label: "Sector",
    multiple: true,
    showMessageMin: true,
    onInput: function onInput(e) {
      return onSearch(e);
    },
    disabled: citieID ? false : true
  });
}

/* harmony default export */ var sector_field = (sector_field_SectorsField);

var sector_field_adapterSectors = function adapterSectors(data) {
  return data.map(function (x) {
    return {
      description: x.description,
      id: x.id
    };
  });
};
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/form-real-estate/mobile-form/index.tsx




function mobile_form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function mobile_form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? mobile_form_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mobile_form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function mobile_form_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
























var MobileForm = function MobileForm(props) {
  var router = (0,next_router.useRouter)();
  var t = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter");
  var bussineTypes = (0,businessTypes/* useIntlBusinessTypes */.l)();
  var CPropertyTypes = (0,property_types/* useIntlPropertyTypes */.Pb)();
  var CPropertyCollection = (0,property_types/* useIntlPropertyCollectionTypes */.j4)();
  var translations = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");

  var _useField = (0,formik_esm/* useField */.U$)("amountMin"),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 1),
      amountMin = _useField2[0].value;

  var _useField3 = (0,formik_esm/* useField */.U$)("amountMax"),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 1),
      amountMax = _useField4[0].value;

  var propertyList = (router.pathname.includes("/collection") ? CPropertyCollection : CPropertyTypes).map(function (x) {
    return mobile_form_objectSpread(mobile_form_objectSpread({}, x), {}, {
      description: x.name,
      id: x.id
    });
  });

  var handleSubmit = function handleSubmit() {
    props.handleToggleModal();
    setTimeout(function () {
      props.handleSubmit();
    }, 500);
  };

  var handleReset = function handleReset() {
    props.handleToggleModal();
    setTimeout(function () {
      props.handleReset();
    }, 500);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerButton, {
    item: true,
    xs: 12,
    bgcolor: "#EFEFF1",
    sx: {
      py: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(FilterButtonOutline, {
    onClick: handleReset
  }, translations("delete")), (0,emotion_react_browser_esm/* jsx */.tZ)(FilterButton, {
    disabled: amountMin && amountMax && +amountMax < +amountMin,
    onClick: handleSubmit
  }, translations("apply"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyItems: "center",
    alignItems: "center",
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(mobile_form_Label, null, t("shop-sell-short"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 8
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_switch_labels/* default */.Z, {
    options: bussineTypes,
    name: "businessTypes"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: true,
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(checkbox_group_v2, {
    column: 2,
    options: [{
      label: "Construida",
      value: true
    }, {
      label: "En construcción",
      value: false,
      textWrap: true
    }],
    name: "onlyUnits",
    checkBoxProps: {
      icon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonUnchecked/* default */.Z, {
        sx: {
          color: "gray"
        }
      }),
      checkedIcon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonChecked/* default */.Z, {
        sx: {
          color: "var(--color-brand-green-main)"
        }
      })
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: true,
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(checkbox_group_v2, {
    column: 2,
    options: [{
      label: translations("furnished"),
      value: 1
    }, {
      label: translations("whiteLine"),
      value: 2
    }],
    multiple: false,
    name: "extraBusinessTypes",
    checkBoxProps: {
      icon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonUnchecked/* default */.Z, {
        sx: {
          color: "gray"
        }
      }),
      checkedIcon: (0,emotion_react_browser_esm/* jsx */.tZ)(RadioButtonChecked/* default */.Z, {
        sx: {
          color: "var(--color-brand-green-main)"
        }
      })
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(FilterAutoComplete, {
    id: "typeProperty",
    showMessageMin: false,
    name: "typeProperty",
    data: propertyList,
    multiple: true,
    label: t("youLookingForMobile")
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(cities_field, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(sector_field, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(code_search_field, null), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyItems: "center",
    alignItems: "center",
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(mobile_form_Label, null, translations("currency"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 8
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_switch_labels/* default */.Z, {
    options: currencyTypes/* CCurrencyTypes */.v,
    name: "currencyType"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    sx: {
      paddingY: 2
    },
    alignItems: "center",
    spacing: 1
  }, amountMin && amountMax && +amountMax < +amountMin ? (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeErrorMessage, null, translations("price_range-error_message")) : null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      marginTop: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(TextFieldMoney, {
    placeholder: translations("minimum"),
    inputComponent: mask_components/* MoneyInput */.PK,
    name: "amountMin"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      marginTop: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(TextFieldMoney, {
    inputComponent: mask_components/* MoneyInput */.PK,
    placeholder: translations("maximum"),
    name: "amountMax"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_ButtonTypesField, {
    label: translations("baths"),
    name: "bathrooms"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_ButtonTypesField, {
    label: translations("half_baths"),
    name: "halfBathrooms"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_ButtonTypesField, {
    label: translations("bedrooms"),
    name: "bedrooms"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_ButtonTypesField, {
    label: translations("parkings"),
    name: "parkings"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_ButtonTypesField, {
    label: translations("level"),
    name: "floorLevels"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    sx: {
      mt: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(improvements_list, {
    columns: 2
  }));
};
var mobile_form_TextFieldCustomShared =  true ? {
  name: "1il269v",
  styles: "background-color:white;padding:20px;border-radius:30px;border:0px solid transparent;box-shadow:rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;& input::placeholder{color:gray;}&*{outline:none;}"
} : 0;

var TextFieldMoney = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(text_field/* default */.Z,  true ? {
  target: "e9spfx46"
} : 0)(mobile_form_TextFieldCustomShared, ";" + ( true ? "" : 0));

var FilterButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e9spfx45"
} : 0)( true ? {
  name: "11ljbam",
  styles: "padding:7px;min-width:45%"
} : 0);

var FilterButtonOutline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e9spfx44"
} : 0)( true ? {
  name: "1sbgdli",
  styles: "padding:7px;min-width:45%;background-color:transparent;border:1px solid gray;color:gray;:hover,:focus{background:transparent;}"
} : 0);

var mobile_form_Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e9spfx43"
} : 0)( true ? {
  name: "18t7d6p",
  styles: "font-size:14px;color:var(--color-brand-blue-main);font-weight:600"
} : 0);

var ContainerButtonFooter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Grid/* default */.ZP,  true ? {
  target: "e9spfx42"
} : 0)( true ? {
  name: "fq7g6r",
  styles: "display:flex;justify-content:center;align-items:center;width:100%;height:80px"
} : 0);

var ContainerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Grid/* default */.ZP,  true ? {
  target: "e9spfx41"
} : 0)( true ? {
  name: "1uaj7xs",
  styles: "position:sticky;top:0;left:0;display:flex;justify-content:space-around;z-index:2"
} : 0);

var PriceRangeErrorMessage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e9spfx40"
} : 0)( true ? {
  name: "1fpix3o",
  styles: "color:var(--color-brand-red-secondary);font-weight:bold;margin-left:10px"
} : 0);
;// CONCATENATED MODULE: ./shared/components/advance-filter-dialog/index.tsx



function advance_filter_dialog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













function AdvanceFilterDialog(props) {
  var _props$refButton;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var width = (0,use_width_hook/* useWidth */.z)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");
  var isMobile = ["xs", "sm"].includes(width);

  var handleToggleModal = function handleToggleModal() {
    setOpen(!open);
  };

  var DialogHeader = function DialogHeader(props) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
      css: stylesDialogHeader.root,
      fontSize: 12,
      align: "right"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      variant: "text",
      colortext: "--color-brand-grey-secondary",
      onClick: function onClick() {
        return props.onClose();
      }
    }, translation("close")));
  };

  var handleReset = props.handleReset,
      handleSubmit = props.handleSubmit;
  var configProp = {
    open: open,
    TransitionComponent: slide_transition/* default */.Z,
    onClose: handleToggleModal,
    keepMounted: false,
    fullWidth: true,
    fullScreen: isMobile,
    maxWidth: "sm"
  };
  var formConfig = {
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    handleToggleModal: handleToggleModal
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, /*#__PURE__*/react.cloneElement(props.children, {
    onClick: handleToggleModal,
    ref: (_props$refButton = props === null || props === void 0 ? void 0 : props.refButton) !== null && _props$refButton !== void 0 ? _props$refButton : null
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogCustom, configProp, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogHeader, configProp), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, isMobile ? (0,emotion_react_browser_esm/* jsx */.tZ)(MobileForm, formConfig) : (0,emotion_react_browser_esm/* jsx */.tZ)(DesktopForm, formConfig))));
}

var DialogCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e1ne5z060"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return {
    "& .MuiDialog-paper": {
      backgroundColor: "#EFEFF1",
      borderRadius: "20px"
    }
  };
},  true ? "" : 0);

var stylesDialogHeader = {
  root:  true ? {
    name: "uq8ggj",
    styles: "text-align:right;font-size:13px;color:var(--color-brand-grey-main);cursor:pointer"
  } : 0
};

/***/ }),

/***/ 69891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ auto_complete_field_AutoCompleteField; },
  "Z": function() { return /* reexport */ auto_complete_field_FormikAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js + 1 modules
var emotion_css_esm = __webpack_require__(18872);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 7 modules
var TextField = __webpack_require__(98271);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js + 4 modules
var Autocomplete = __webpack_require__(39902);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/auto-complete-field/AutoCompleteField.tsx



var _excluded = ["label", "options", "onInputChange", "value", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function AutoCompleteField(props) {
  // const INPUT_DELAY = props?.INPUT_DELAY ?? 500;
  var INPUT_DELAY = 0;

  var label = props.label,
      options = props.options,
      onInputChange = props.onInputChange,
      value = props.value,
      onChange = props.onChange,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var inputChangeHandler = function inputChangeHandler(event, inputValue, reason) {
    if (props.onInputChange) {
      props.onInputChange(event, inputValue, reason);
    }
  };

  var debounceHandler = (0,react.useCallback)((0,debounce/* default */.Z)(function (event, inputValue, reason) {
    inputChangeHandler(event, inputValue, reason);
  }, INPUT_DELAY), []);
  var handleOnInputChange = (0,react.useCallback)(function (event, inputValue, reason) {
    event === null || event === void 0 ? void 0 : event.persist();
    debounceHandler(event, inputValue, reason);
  }, []);

  var FieldComponent = function FieldComponent(params) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(TextField/* default */.Z, (0,esm_extends/* default */.Z)({}, params, rest, {
      InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
        endAdornment: (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, props.loading ? (0,emotion_react_browser_esm/* jsx */.tZ)(CircularProgress/* default */.Z, {
          color: "primary",
          size: 20
        }) : null, params.InputProps.endAdornment)
      })
    }));
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
    label: props.label,
    positionLabel: props.positionLabel
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Autocomplete/* default */.Z, (0,esm_extends/* default */.Z)({
    disabledItemsFocusable: true,
    openOnFocus: true,
    options: options,
    renderInput: FieldComponent,
    onInputChange: handleOnInputChange,
    PaperComponent: CustomPaper,
    onChange: onChange,
    value: value,
    includeInputInList: true,
    disableClearable: true,
    loadingText: "Cargando...",
    noOptionsText: "Sin resultados",
    getOptionDisabled: function getOptionDisabled(option) {
      return value.map(function (x) {
        return x.id;
      }).includes(option.id);
    }
  }, rest)));
}

var CustomPaper = function CustomPaper(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Paper/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    className: /*#__PURE__*/(0,emotion_css_esm/* css */.iv)( true ? {
      name: "17z5cnh",
      styles: "font-size:14px;font-family:var(--font-family);text-transform:uppercase;font-weight:500;& .MuiAutocomplete-option{color:#989694;font-weight:500;:hover{color:white;opacity:1;background:var(--color-brand-blue-main) !important;}}& .MuiAutocomplete-groupLabel{color:var(--color-brand-blue-main);font-weight:800;}"
    } : 0)
  }));
};

/* harmony default export */ var auto_complete_field_AutoCompleteField = (AutoCompleteField);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
;// CONCATENATED MODULE: ./shared/components/auto-complete-field/FormikAutocomplete.tsx



var FormikAutocomplete_excluded = ["name"];





function FormikAutocomplete(props) {
  var name = props.name,
      rest = (0,objectWithoutProperties/* default */.Z)(props, FormikAutocomplete_excluded);

  var _useField = (0,formik_esm/* useField */.U$)({
    name: name
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var onChange = function onChange(e, s) {
    helpers.setValue(s);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(auto_complete_field_AutoCompleteField, (0,esm_extends/* default */.Z)({}, rest, {
    value: field.value,
    onChange: onChange
  }));
}

/* harmony default export */ var auto_complete_field_FormikAutocomplete = (FormikAutocomplete);
;// CONCATENATED MODULE: ./shared/components/auto-complete-field/index.tsx




/***/ }),

/***/ 2553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ makeFilterObject; },
/* harmony export */   "Z": function() { return /* binding */ FormConfig; }
/* harmony export */ });
/* harmony import */ var shared_models_functions_realestate_filters_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31248);

var FormConfig = {
  initialValues: {
    city: [],
    sector: [],
    typeProperty: [],
    locations: [],
    amountMax: null,
    amountMin: null,
    bathrooms: null,
    halfBathrooms: null,
    bedrooms: [],
    currencyType: "us",
    floorLevels: null,
    parkings: null,
    onlyUnits: [],
    // propertyStatus: ["1"],
    realEstateType: null,
    search: "",
    businessTypes: "sale",
    improvements: [],
    price: "",
    extraBusinessTypes: ''
  }
};
var makeFilterObject = function makeFilterObject(value) {
  var filters = (0,shared_models_functions_realestate_filters_helper__WEBPACK_IMPORTED_MODULE_0__/* .parseRealestateFiltersToUrl */ .Y_)(value);
  return filters;
};

/***/ }),

/***/ 52659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MessageResults; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var MessageResults = function MessageResults(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(MessageContent, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", null, props.message, " ", (props === null || props === void 0 ? void 0 : props.modalComponent) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(props.modalComponent, {})));
};

var MessageContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ef5l1rl0"
} : 0)( true ? {
  name: "11ru1eu",
  styles: "height:calc(100vh - 375px);display:flex;justify-content:center;align-items:center;& span{font-size:19px;font-weight:600;color:var(--color-brand-grey-main);max-width:800px;text-align:center;}"
} : 0);

/***/ }),

/***/ 97472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




var SliderTransition = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Transition(props, ref) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    direction: "up",
    ref: ref
  }, props));
});
/* harmony default export */ __webpack_exports__["Z"] = (SliderTransition);

/***/ }),

/***/ 58169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DefaultSwitchLabels; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



function DefaultSwitchLabels(props) {
  var value = props.value,
      options = props.options,
      onChange = props.onChange;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ContentSw, {
    className: "content-switch-label"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    className: options[0].value == value ? "a" : "b"
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
    onClick: function onClick() {
      return onChange(options[0].value);
    }
  }, options[0].label), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
    onClick: function onClick() {
      return onChange(options[1].value);
    }
  }, options[1].label));
}

var ContentSw = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e17sgyeg0"
} : 0)( true ? {
  name: "pa6iwc",
  styles: "width:100%;background:gray;min-width:150px;display:flex;justify-content:space-between;height:40px;border-radius:20px;color:white;position:relative;font-size:15px;cursor:pointer;span{position:relative;border-radius:20px;max-width:50%;width:100%;text-align:center;display:flex;align-items:center;justify-content:center;z-index:1;padding:5px;font-family:\"Arial\";}div{position:absolute;height:100%;width:50%;z-index:1;border-radius:20px;background:var(--color-brand-blue-main);&.a{transform:translateX(0%);transition:all 0.8s ease;}&.b{transform:translateX(100%);transition:all 0.8s ease;}}"
} : 0);

/***/ }),

/***/ 16447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormikSwitchLabels; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17674);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _default_switch_labels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58169);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);





function FormikSwitchLabels(props) {
  var name = props.name,
      options = props.options;

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)({
    name: name
  }),
      _useField2 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var handleClick = function handleClick(value) {
    helpers.setValue(value);
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_default_switch_labels__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    onChange: handleClick,
    options: options,
    value: field.value
  });
}

/***/ }),

/***/ 80074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CBusinessTypes; },
/* harmony export */   "l": function() { return /* binding */ useIntlBusinessTypes; }
/* harmony export */ });
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_0__);

function useIntlBusinessTypes() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("formRealestateFilters");
  var CBusinessTypes = [{
    label: translation("sale"),
    value: "sale"
  }, {
    label: translation("lease"),
    value: "lease"
  }];
  return CBusinessTypes;
}
var CBusinessTypes = [{
  label: "Venta",
  value: "sale"
}, {
  label: "Alquiler",
  value: "lease"
}];

/***/ }),

/***/ 83479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ CCurrencyTypes; }
/* harmony export */ });
var CCurrencyTypes = [{
  label: "USD",
  value: "us"
}, {
  label: "DOP",
  value: "rd"
}];

/***/ }),

/***/ 12930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RX": function() { return /* binding */ staticImprovementMapSpanish; },
/* harmony export */   "tH": function() { return /* binding */ useIntlImprovements; },
/* harmony export */   "xZ": function() { return /* binding */ useIntlImprovementsMap; }
/* harmony export */ });
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_0__);

;
var savedLocale;
var CImprovements = [];
function useIntlImprovements() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("formRealestateFilters");
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedLocale !== locale) CImprovements = [];
  if (CImprovements.length) return CImprovements;
  CImprovements = [{
    value: 15,
    label: translation("balcony")
  }, {
    value: 16,
    label: translation("foyer")
  }, {
    value: 17,
    label: translation("livingRoom")
  }, {
    value: 18,
    label: translation("livingDiningRoom")
  }, {
    value: 19,
    label: translation("diningRoom")
  }, {
    value: 20,
    label: translation("room")
  }, {
    value: 21,
    label: translation("pantry")
  }, {
    value: 22,
    label: translation("kitchen")
  }, {
    value: 26,
    label: translation("cistern")
  }, {
    value: 27,
    label: translation("breakfastRoom")
  }, {
    value: 28,
    label: translation("studio")
  }, {
    value: 29,
    label: translation("familyRoom")
  }, {
    value: 31,
    label: translation("ladder")
  }, {
    value: 32,
    label: translation("elevator")
  }, {
    value: 33,
    label: translation("coveredTerrace")
  }, {
    value: 73,
    label: translation("terrace")
  }, {
    value: 74,
    label: translation("gazebo")
  }, {
    value: 76,
    label: translation("swimmingPool")
  }, {
    value: 80,
    label: translation("courtyard")
  }, {
    value: 85,
    label: translation("parking")
  }, {
    value: 86,
    label: translation("roofedParking")
  }, {
    value: 87,
    label: translation("mezzanine")
  }, {
    value: 89,
    label: translation("jacuzzi")
  }, {
    value: 90,
    label: translation("services")
  }, {
    value: 91,
    label: translation("washing")
  }, {
    value: 93,
    label: translation("telecable")
  }, {
    value: 94,
    label: translation("cornices")
  }, {
    value: 95,
    label: translation("gates")
  }, {
    value: 96,
    label: translation("waterTank")
  }, {
    value: 98,
    label: translation("well")
  }, {
    value: 99,
    label: translation("aC")
  }, {
    value: 100,
    label: translation("fans")
  }, {
    value: 102,
    label: translation("transferA")
  }, {
    value: 103,
    label: translation("inverter")
  }, {
    value: 104,
    label: translation("heater")
  }, {
    value: 105,
    label: translation("filters")
  }, {
    value: 106,
    label: translation("annexes")
  }, {
    value: 107,
    label: translation("phone")
  }, {
    value: 153,
    label: translation("grids")
  }, {
    value: 154,
    label: translation("powerPlant")
  }, {
    value: 155,
    label: translation("fullPowerPlant")
  }, {
    value: 241,
    label: translation("aCCentral")
  }, {
    value: 242,
    label: translation("aCPreinstalled")
  }, {
    value: 243,
    label: translation("aCSplit")
  }, {
    value: 244,
    label: translation("socialAreas")
  }, {
    value: 246,
    label: translation("janitor")
  }, {
    value: 247,
    label: translation("electricGate")
  }, {
    value: 248,
    label: translation("roofAccess")
  }, {
    value: 249,
    label: translation("commonBathroom")
  }, {
    value: 250,
    label: translation("garbageDuct")
  }, {
    value: 251,
    label: translation("locker")
  }, {
    value: 252,
    label: translation("escape")
  }, {
    value: 253,
    label: translation("gym")
  }, {
    value: 254,
    label: translation("activitiesRoom")
  }];
  savedLocale = locale;
  return CImprovements;
}
var savedMapLocale;
var CImprovementsMap = new Map();
function useIntlImprovementsMap() {
  var vals = useIntlImprovements();
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedMapLocale !== locale) CImprovementsMap.clear();
  if (CImprovementsMap.size === 0) vals.forEach(function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    return CImprovementsMap.set(value, label);
  });
  savedMapLocale = locale;
  return CImprovementsMap;
}
var staticImprovementMapSpanish = new Map([[15, "Balcón"], [16, "Recibidor"], [17, "Sala"], [18, "Sala/Comedor"], [19, "Comedor"], [20, "Estar"], [21, "Pantry"], [22, "Cocina"], [26, "Cisterna"], [27, "Desayunador"], [28, "Estudio"], [29, "Family Room"], [31, "Escaleras"], [32, "Ascensor"], [33, "Terraza techada"], [73, "Terraza"], [74, "Gazebo"], [76, "Piscina"], [80, "Patio"], [85, "Parqueo"], [86, "Parq. Techado"], [87, "Mezzanine"], [89, "Jacuzzi"], [90, "Servicio"], [91, "Lavado"], [93, "Telecable"], [94, "Cornisas"], [95, "Verjas"], [96, "Tinaco"], [98, "Pozo"], [99, "A/C"], [100, "Abanicos"], [102, "Transfer/A"], [103, "Inversor"], [104, "Calentador"], [105, "Filtros"], [106, "Anexos"], [107, "Teléfono"], [153, "Rejas"], [154, "Planta Eléctrica (Común)"], [155, "Planta Eléctrica Full"], [241, "A/C Central"], [242, "A/C Preinstalado"], [243, "A/C Split"], [244, "Areas sociales"], [246, "Conserje"], [247, "Portón Eléctrico"], [248, "Acceso a Techo"], [249, "Baño Común"], [250, "Ducto Basura"], [251, "Locker"], [252, "Esc. Emergencia"], [253, "Gimnasio"], [254, "Salon de Actividades"]]);

/***/ }),

/***/ 86465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pb": function() { return /* binding */ useIntlPropertyTypes; },
/* harmony export */   "Rl": function() { return /* binding */ CPropertyTypes; },
/* harmony export */   "j4": function() { return /* binding */ useIntlPropertyCollectionTypes; },
/* harmony export */   "xP": function() { return /* binding */ useIntlPropertyTypesMap; }
/* harmony export */ });
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_0__);

;
var savedLocale;
var CPropertyTypesArray = [];
function useIntlPropertyTypes() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("realestateList.typeFilters");
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedLocale !== locale) CPropertyTypesArray = [];
  if (CPropertyTypesArray.length) return CPropertyTypesArray;
  CPropertyTypesArray = [{
    id: 1,
    name: translation("apartment"),
    slug: "apartment"
  }, {
    id: 2,
    name: translation("house"),
    slug: "house"
  }, {
    id: 3,
    name: translation("commercialPremises"),
    slug: "comercial+site"
  }, {
    id: 4,
    name: translation("industrialSite"),
    slug: "industrial+site"
  }, {
    id: 5,
    name: translation("estate"),
    slug: "estate"
  }, {
    id: 6,
    name: translation("land"),
    slug: "land"
  }, {
    id: 7,
    name: translation("business"),
    slug: "office"
  }, {
    id: 8,
    name: translation("building"),
    slug: "building"
  }, {
    id: 9,
    name: translation("tourist"),
    slug: "turistic"
  }, {
    id: 10,
    name: translation("hotel"),
    slug: "hotel"
  }, {
    id: 12,
    name: translation("housePlot"),
    slug: "house+or+land"
  }, {
    id: 13,
    name: translation("buildingPlot"),
    slug: "building+or+land"
  }, {
    id: 14,
    name: translation("project"),
    slug: "project"
  }, {
    id: 15,
    name: translation("penthouse"),
    slug: "penthouse"
  }, {
    id: 16,
    name: translation("gasStation"),
    slug: "gasstation"
  }, {
    id: 17,
    name: translation("office"),
    slug: "office+site"
  }];
  return CPropertyTypesArray;
}
var savedMapLocale;
var propertyTypesSlugMap = new Map();
function useIntlPropertyTypesMap() {
  var vals = useIntlPropertyTypes();
  var locale = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useLocale)();
  if (savedMapLocale !== locale) propertyTypesSlugMap.clear();

  if (propertyTypesSlugMap.size === 0) {
    vals.forEach(function (el) {
      return propertyTypesSlugMap.set(el.slug, el);
    });
  }

  savedMapLocale = locale;
  return propertyTypesSlugMap;
}
function useIntlPropertyCollectionTypes() {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_0__.useTranslations)("realestateList.typeFilters");
  var CPropertyCollection = [{
    id: 1,
    name: translation("apartment"),
    slug: "apartment"
  }, {
    id: 2,
    name: translation("house"),
    slug: "house"
  }, {
    id: 9,
    name: translation("tourist"),
    slug: "turistic"
  }, {
    id: 14,
    name: translation("project"),
    slug: "project"
  }, {
    id: 15,
    name: translation("penthouse"),
    slug: "penthouse"
  }];
  return CPropertyCollection;
}
var CPropertyTypes = [{
  id: 1,
  name: "Apartamento",
  plural: "Apartamentos",
  slug: "apartment"
}, {
  id: 2,
  name: "Casa",
  plural: "Casas",
  slug: "house"
}, {
  id: 3,
  name: "Local Comercial",
  plural: "Locales Comerciales",
  slug: "comercial+site"
}, {
  id: 4,
  name: "Nave Industrial",
  plural: "Naves Industriales",
  slug: "industrial+site"
}, {
  id: 5,
  name: "Finca",
  plural: "Fincas",
  slug: "estate"
}, {
  id: 6,
  name: "Terreno",
  plural: "Terrenos",
  slug: "land"
}, {
  id: 7,
  name: "Negocio",
  plural: "Negocios",
  slug: "office"
}, {
  id: 8,
  name: "Edificio",
  plural: "Edificios",
  slug: "building"
}, {
  id: 9,
  name: "Turístico",
  plural: "Turísticos",
  slug: "turistic"
}, {
  id: 10,
  name: "Hotel",
  plural: "Hoteles",
  slug: "hotel"
}, {
  id: 12,
  name: "Casa o Solar",
  plural: "Casas o Solares",
  slug: "house+or+land"
}, {
  id: 13,
  name: "Edificio o Solar",
  plural: "Edificios o Solares",
  slug: "building+or+land"
}, {
  id: 14,
  name: "Proyecto",
  plural: "Proyectos",
  slug: "project"
}, {
  id: 15,
  name: "Penthouse",
  plural: "Penthouses",
  slug: "penthouse"
}, {
  id: 16,
  name: "Estación de Combustible",
  plural: "Estaciones de Combustible",
  slug: "gasstation"
}, {
  id: 17,
  name: "Local de Oficina",
  plural: "Locales de Oficina",
  slug: "office+site"
}];

/***/ }),

/***/ 75769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ sortCities; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function sortCities(cities) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "desc";
  return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.orderBy)(cities, [function (_ref) {
    var id = _ref.id;
    return [1, 150, 149, 148].includes(id);
  }, "id"], [order]);
}

/***/ }),

/***/ 23622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ queryFormatter; },
/* harmony export */   "HL": function() { return /* binding */ queryParserUrl; }
/* harmony export */ });
/* unused harmony export queryParser */
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var defaultQueryFormatterOptions = {
  skipEmptyString: true,
  skipNull: true,
  arrayFormat: "bracket"
};
var defaultQueryParserOptions = {
  arrayFormat: "bracket"
};
function queryFormatter(data, options) {
  return query_string__WEBPACK_IMPORTED_MODULE_1__.stringify(data, _objectSpread(_objectSpread({}, defaultQueryFormatterOptions), options));
}
function queryParser(data, options) {
  return querystring.parse(data, _objectSpread(_objectSpread({}, defaultQueryParserOptions), options));
}
function queryParserUrl(data, options) {
  return query_string__WEBPACK_IMPORTED_MODULE_1__.parseUrl(data, _objectSpread(_objectSpread({}, defaultQueryParserOptions), options));
}

/***/ }),

/***/ 31248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y_": function() { return /* binding */ parseRealestateFiltersToUrl; },
  "Ym": function() { return /* binding */ parseUrlToRealestateFilters; }
});

// UNUSED EXPORTS: validatePriceRange

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./shared/models/const/improvements.conts.ts
var improvements_conts = __webpack_require__(12930);
;// CONCATENATED MODULE: ./shared/models/functions/price-range-param.helper.ts
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Para venta:
// Dolares
//     Bajo costo: $40,000 a $88,888
//     Moderado: $88,889 a $150,000
//     Moderado-Alto: $150,001 a $250,000
//     Alto: $250,001 a $400,000
//     Premium: $400,001 a $599,999
//     Colección o lujo: $600,000 en adelante
// Pesos
//     Bajo costo (BC): RD$ 2,160,000 a RD$ 4,799,952
//     Moderado (MD): RD$ 4,799,953 a RD$ 8,100,000
//     Moderado-Alto (MA): RD$ 8,100,001 a RD$ 13,500,054
//     Alto (AT): RD$ 13,500,055 a RD$ 21,600,000
//     Premium (PM): RD$ 21,600,001 a RD$ 32,399,946
//     Colección o lujo (CL): RD$ 32,400,000 en adelante
// Estos son los valores que se enviaran dependiendo en que renglón caen
//     Bajo costo: BC
//     Moderado: MD
//     Moderado-Alto: MA
//     Alto: AT
//     Premium: PM
//     Colección o lujo: CL
// Enviar parametro: 
// mm={tipo_perfil} cuando sea asignado el precio minimo
// mma={tipo_perfil} cuando sea asignado el precio maximo
// Alquiler
//     Bajo costo (BC): $250 a $500
//     Moderado (MD): $501 a $1000
//     Moderado-Alto (MA): $1001 a $1500
//     Alto (AT): $1501 a $2000
//     Premium (PM): $2001 a $2500
//     Colección o lujo (CL): $2501 en adelante
//     Bajo costo (BC): RD$ 13,750 a RD$ 27,500
//     Moderado (MD): RD$ 27,501 a RD$ 55,000
//     Moderado-Alto (MA): RD$ 55,001 a RD$ 82,500
//     Alto (AT): RD$ 82,501 a RD$ 110,000
//     Premium (PM): RD$ 110,001 a RD$ 137,500
//     Colección o lujo (CL): RD$ 137,501 en adelante
// Estos son los valores que se enviaran dependiendo en que renglón caen
//     Bajo costo: ABC
//     Moderado: AMD
//     Moderado-Alto: AMA
//     Alto: AAT
//     Premium: APM
//     Colección o lujo: ACL
// Enviar parámetro: 
// mm={tipo_perfil} cuando sea asignado el precio minimo
// mma={tipo_perfil} cuando sea asignado el precio maximo
var priceRanges = {
  sale: {
    us: [{
      min: 40000,
      category: 'bc'
    }, {
      min: 88889,
      category: 'md'
    }, {
      min: 150001,
      category: 'ma'
    }, {
      min: 250001,
      category: 'at'
    }, {
      min: 400001,
      category: 'pm'
    }, {
      min: 600000,
      category: 'cl'
    }],
    rd: [{
      min: 2160000,
      category: 'bc'
    }, {
      min: 4799953,
      category: 'md'
    }, {
      min: 8100001,
      category: 'ma'
    }, {
      min: 13500055,
      category: 'at'
    }, {
      min: 21600001,
      category: 'pm'
    }, {
      min: 32400000,
      category: 'cl'
    }],
    "default": "sp"
  },
  lease: {
    us: [{
      min: 250,
      category: 'abc'
    }, {
      min: 501,
      category: 'amd'
    }, {
      min: 1001,
      category: 'ama'
    }, {
      min: 1501,
      category: 'aat'
    }, {
      min: 2001,
      category: 'apm'
    }, {
      min: 2501,
      category: 'acl'
    }],
    rd: [{
      min: 13750,
      category: 'abc'
    }, {
      min: 27501,
      category: 'amd'
    }, {
      min: 55001,
      category: 'ama'
    }, {
      min: 82501,
      category: 'aat'
    }, {
      min: 110001,
      category: 'apm'
    }, {
      min: 137501,
      category: 'acl'
    }],
    "default": "asp"
  }
};
var lastValidValue = "";
function getPriceRangeParam(_ref) {
  var amountMin = _ref.amountMin,
      amountMax = _ref.amountMax,
      currencyType = _ref.currencyType,
      businessTypes = _ref.businessTypes;
  var resultMax = null;
  var resultMin = null;
  var resultParams = "";
  if (!amountMax && !amountMin) return lastValidValue;
  if (amountMax && amountMin && +amountMax < +amountMin) return lastValidValue;

  try {
    var _resultMin, _resultMax, _resultParams;

    var prices = priceRanges[businessTypes];

    var _iterator = _createForOfIteratorHelper(prices[currencyType]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var range = _step.value;

        if (amountMin) {
          if (+amountMin >= range.min) {
            resultMin = range.category;
          }
        }

        if (amountMax) {
          if (+amountMax >= range.min) {
            resultMax = range.category;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    resultParams = "".concat(amountMin ? "&mm=" + ((_resultMin = resultMin) !== null && _resultMin !== void 0 ? _resultMin : prices["default"]) : "") + "".concat(amountMax ? "&mma=" + ((_resultMax = resultMax) !== null && _resultMax !== void 0 ? _resultMax : prices["default"]) : "");
    lastValidValue = (_resultParams = resultParams) !== null && _resultParams !== void 0 ? _resultParams : lastValidValue;
    return lastValidValue;
  } catch (error) {
    return lastValidValue;
  }
}
// EXTERNAL MODULE: ./shared/models/functions/query-string-helper.ts
var query_string_helper = __webpack_require__(23622);
;// CONCATENATED MODULE: ./shared/models/functions/realestate-filters-helper.ts



var _excluded = ["city", "locations", "typeProperty", "sector", "onlyUnits"],
    _excluded2 = ["city", "locations", "sector", "typeProperty"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var parseRealestateFiltersToUrl = function parseRealestateFiltersToUrl(values) {
  var _locations$at, _rest$improvements;

  var city = values.city,
      locations = values.locations,
      _values$typeProperty = values.typeProperty,
      typeProperty = _values$typeProperty === void 0 ? [] : _values$typeProperty,
      sector = values.sector,
      onlyUnits = values.onlyUnits,
      rest = (0,objectWithoutProperties/* default */.Z)(values, _excluded);

  var formattedUrl = (0,query_string_helper/* queryFormatter */.Bt)(_objectSpread(_objectSpread({}, rest), validatePriceRange(rest)));
  var typePropertyFilters = getTypeProperty(typeProperty);
  var locationsFilters = serializeArrayOfObject(locations);
  var SectorFilters = serializeArrayOfObject(sector);
  var ciudad = locations === null || locations === void 0 ? void 0 : (_locations$at = locations.at(0)) === null || _locations$at === void 0 ? void 0 : _locations$at.description;
  var sectores = sector === null || sector === void 0 ? void 0 : sector.map(function (sector) {
    return sector.description;
  }).join('|');
  var complexFilters = (0,query_string_helper/* queryFormatter */.Bt)({
    typeProperty: typePropertyFilters,
    locations: locationsFilters,
    sector: SectorFilters,
    onlyUnits: onlyUnits
  });
  if (complexFilters) formattedUrl += '&' + complexFilters; //Add cosmetic/stats params (should be removed in parseUrlToRealestateFilters)

  if (ciudad) formattedUrl += '&ciudad=' + ciudad;
  if (sectores) formattedUrl += '&sectores=' + sectores;
  if (onlyUnits !== null && onlyUnits !== void 0 && onlyUnits.length && onlyUnits.length < 2) formattedUrl += formatOnlyUnitsParams(onlyUnits);
  if (rest.amountMax || rest.amountMin) formattedUrl += getPriceRangeParam(values);
  if ((_rest$improvements = rest.improvements) !== null && _rest$improvements !== void 0 && _rest$improvements.length) formattedUrl += formatImprovementsParams(rest.improvements);
  return formattedUrl;
};
var lastValidPriceRange = {};
var validatePriceRange = function validatePriceRange(_ref) {
  var amountMax = _ref.amountMax,
      amountMin = _ref.amountMin;
  if (amountMax && amountMin && +amountMax < +amountMin) return lastValidPriceRange;
  lastValidPriceRange = {
    amountMax: amountMax,
    amountMin: amountMin
  };
  return lastValidPriceRange;
};

function formatOnlyUnitsParams(onlyUnits) {
  return '&tipo_construccion=' + (onlyUnits[0] === 'true' ? 'construida' : 'en construccion');
}

function formatImprovementsParams(improvements) {
  return "&amenidades=" + improvements.map(function (imp) {
    return improvements_conts/* staticImprovementMapSpanish.get */.RX.get(+imp);
  }).join("|");
}

var parseUrlToRealestateFilters = function parseUrlToRealestateFilters(values) {
  var city = values.city,
      locations = values.locations,
      sector = values.sector,
      _values$typeProperty2 = values.typeProperty,
      typeProperty = _values$typeProperty2 === void 0 ? [] : _values$typeProperty2,
      rest = (0,objectWithoutProperties/* default */.Z)(values, _excluded2);

  var locationFilters = serializeArrayOfString(locations);
  var sectorFilters = serializeArrayOfString(sector); //Remove cosmetic/stats params

  ['ciudad', 'sectores', 'tipo_construccion', 'mm', 'mma', 'amenidades'].map(function (prop) {
    return delete rest[prop];
  });
  return _objectSpread({
    locations: locationFilters,
    typeProperty: typeProperty,
    sector: sectorFilters
  }, rest);
}; // We are serializing Array of object into this kind of notation
// Array[] = ["key-value&"]
// the & is just a delimiter

function serializeArrayOfObject() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newArray = [];

  var _loop = function _loop(index) {
    var element = array[index];

    var _string = Object.keys(element).reduce(function (prev, current) {
      return prev + "".concat(current, "-").concat(element[current], "&");
    }, "");

    newArray.push(_string);
  };

  for (var index = 0; index < array.length; index++) {
    _loop(index);
  }

  return newArray;
} // setting back the array of string we get from the url
// thanks to the previous function


function serializeArrayOfString() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newArray = [];

  var _loop2 = function _loop2(index) {
    var element = array[index];
    var keyValues = element.split("&").filter(function (e) {
      return e != "";
    });
    var obj = {};
    keyValues.forEach(function (keyValue) {
      var _keyValue$split = keyValue.split("-"),
          _keyValue$split2 = (0,slicedToArray/* default */.Z)(_keyValue$split, 2),
          key = _keyValue$split2[0],
          value = _keyValue$split2[1];

      var finalValue = value;

      if (value == "true" || value == "false") {
        finalValue = value == "true";
      }

      obj[key] = finalValue;
    });
    newArray.push(obj);
  };

  for (var index = 0; index < array.length; index++) {
    _loop2(index);
  }

  return newArray;
} // function transformSpecialFilters(value: string) {
//   if (!value.includes(">") && parseInt(value) >= 5) {
//     return ">4";
//   }
//   return value;
// }
// function concatSpecialFilters(value: string, property: string) {
//   if (value) {
//     return "&" + queryFormatter({ [property]: transformSpecialFilters(value) });
//   }
//   return "";
// }


function getTypeProperty() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return types.map(function (item) {
    if (item !== null && item !== void 0 && item.slug) {
      return item.slug;
    }

    if (item !== null && item !== void 0 && item.value) {
      return item.value;
    }

    if (typeof item === "string") {
      return item;
    }

    return "";
  });
}

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ })

}]);